/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackcontinuebutton3Inputs */

const en_authcallbackcontinuebutton3 = /** @type {(inputs: Authcallbackcontinuebutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue to your cases`)
};

const pt_authcallbackcontinuebutton3 = /** @type {(inputs: Authcallbackcontinuebutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar para os meus casos`)
};

/**
* | output |
* | --- |
* | "Continue to your cases" |
*
* @param {Authcallbackcontinuebutton3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackcontinuebutton3 = /** @type {((inputs?: Authcallbackcontinuebutton3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackcontinuebutton3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackcontinuebutton3(inputs)
	return pt_authcallbackcontinuebutton3(inputs)
});
export { authcallbackcontinuebutton3 as "authCallbackContinueButton" }